<script lang="ts">
import { computed, defineComponent } from 'vue';

import Radio from '@/components/base/form/Radio.vue';

export default defineComponent({
  name: 'DeliveryOrPickup',
  props: {
    modelValue: { required: true, type: Boolean },
  },
  components: {
    Radio,
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const isPickup = computed({
      get: () => props.modelValue,
      set: (val) => emit('update:modelValue', val),
    });

    return {
      isPickup,
    };
  },
});
</script>

<template>
  <div
    class="flex mt-6"
    aria-label="Delivery Or Pickup"
    data-test="delivery-or-pickup-list"
    role="radiogroup"
  >
    <Radio
      v-model="isPickup"
      aria-label="Delivery"
      name="shipping-method"
      class="text-base font-normal"
      :value="false"
    >
      Delivery
    </Radio>
    <Radio
      v-model="isPickup"
      aria-label="Pickup"
      name="shipping-method"
      class="ml-6 text-base font-normal"
      :value="true"
    >
      Pickup (for Employee Orders Only)
    </Radio>
  </div>
</template>
